import React from 'react';

export default function Spinner() {
  return <div className="spinner-overlay"><i className="icon-b icon-b-spinner" /></div>;
}
